import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { Manhattan } from '/screens/';

export default function ManhattanPage() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="logistics integrations, logistics partners, manahatten partners"
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        title="Logistics Partners | Manhattan"
        description="Our integration with Manhattan Associates helps you move more with less by delivering real-time market rates and automated booking natively into Manhattan Active® Transportation Management."
        canonical="https://loadsmart.com/integrations/manhattan/"
        openGraph={{
          url: 'https://loadsmart.com/integrations/manhattan/',
        }}
      />
      <Manhattan />
    </>
  );
}
